import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';


function SrcsetImage({ alt, className, sizes, src, variants }) {
  const sources = [];
  for (let i = 0; i < variants.length; i += 1) {
    const size = variants[i];
    const url = buildThumbnailUrl(src, { width: size, height: size });
    sources.push(`${url} ${size}w`);
  }
  const srcSet = sources.join(', ');

  let srcsetSizes = sizes;
  if (typeof sizes === 'number') {
    srcsetSizes = `${sizes}vw`;
  }

  return (
    <img
      className={className}
      srcSet={srcSet}
      sizes={srcsetSizes}
      src={src}
      alt={alt}
    />
  );
}

SrcsetImage.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  /** width of image on page as an approximate percentage of viewport width,
  or else a string that is a valid value for an HTML `sizes` attribute */
  sizes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** thumbnail variations to create, sized in pixels */
  variants: PropTypes.arrayOf(PropTypes.number),
};

SrcsetImage.defaultProps = {
  className: '',
  sizes: 100,
  variants: [420, 850, 1200, 1600, 1920, 2400],
};

export default SrcsetImage;



// WEBPACK FOOTER //
// ./src/components/SrcsetImage.js